import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { ProcessActivityAsset } from '@common/validation/processActivityAsset';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { getProcessActivityAssetsSchema } from '@common/validation/processActivityAsset';
import { addAllowNull } from '@common/validation/utils/addAllowNull';
import { getTextAreaStringSchema } from '@common/validation/utils/getTextAreaStringSchema';

export type BariPreMedConsultExamResultsData = {
    assets: ProcessActivityAsset[];
    toelichting: string | null;
};

export type BariPreMedConsultExamResultsReadKey = keyof BariPreMedConsultExamResultsData;
export type BariPreMedConsultExamResultsReadLabel = 'Bestand(en) met uitslagen' | 'Toelichting';

export const bariPreMedConsultExamResultsReadSchema: TypedReadSchema<
    BariPreMedConsultExamResultsReadKey,
    BariPreMedConsultExamResultsReadLabel
>[] = [
    { items: [{ key: 'assets', label: 'Bestand(en) met uitslagen' }] },
    { items: [{ key: 'toelichting', label: 'Toelichting' }] },
];

const bariPreMedConsultExamResultsFinal: TypedSchema<BariPreMedConsultExamResultsData> = {
    assets: getProcessActivityAssetsSchema({ min: 1 }),
    toelichting: getTextAreaStringSchema(),
};

const bariPreMedConsultExamResultsDraft: TypedSchema<BariPreMedConsultExamResultsData> = addAllowNull(
    {
        ...bariPreMedConsultExamResultsFinal,
        assets: getProcessActivityAssetsSchema(),
    },
    ['assets']
);

export const bariPreMedConsultExamResultsDraftSchema = Koi.object(bariPreMedConsultExamResultsDraft);
export const bariPreMedConsultExamResultsFinalSchema = Koi.object(bariPreMedConsultExamResultsFinal);
